import DesignSystem from '@locaweb/design-system-vue'
import '@locaweb/design-system-vue/dist/locastyle.css'
import locales from '@/locales'
import { makeServer } from '@/server'
import routes from '@/router'
import IconsPlugin from '@locaweb/design-system-icons'
import { PiniaVuePlugin } from 'pinia'
import VueCookies from 'vue-cookies'
import gEvents from '@/ga'

export default {
  install (vue) {
    vue.use(PiniaVuePlugin)
    vue.use(DesignSystem, {
      locales,
      env: process.env.NODE_ENV,
      sentry: {
        dsn: '' // Token do Sentry
      },
      router: { routes },
      http: {
        baseURL: process.env.VUE_APP_API_BASE_URL,
        AuthorizationCookieName: process.env.VUE_APP_COOKIE_NAME
      },
      gtm: {
        id: process.env.VUE_APP_TAG_MANAGER
      },
      gEvents
    })
    vue.use(IconsPlugin)
    if (process.env.VUE_APP_ENABLE_MIRAGE === 'true' && process.env.NODE_ENV !== 'test') {
      VueCookies.set(process.env.VUE_APP_COOKIE_NAME, process.env.VUE_APP_TEST_TOKEN)
      makeServer()
    }
  }
}
